import React from 'react';
import { Link } from '@/shared/ui/link';

export const LogoLink = ({ children, formatUrl, isNotMain }) => (
  <Link
    style={{ display: 'flex', alignItems: 'center' }}
    href={isNotMain ? formatUrl('/') : '#'}
    onClick={(e) => {
      if (!isNotMain) {
        e.preventDefault();
      }
    }}
  >
    {children}
  </Link>
);
